/**
 * Converts base64 binary data (same format as utils/downloadFile.js) to a blob
 * URL for preview. Call revoke() when the URL is no longer needed.
 */
export function base64ToObjectUrl(
  base64Data: string,
  mimeType = 'application/pdf'
): {
  objectUrl: string;
  revoke: () => void;
} {
  const binary = atob(base64Data.replace(/\s/g, ''));
  const len = binary.length;
  const buffer = new ArrayBuffer(len);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }
  const blob = new Blob([view], { type: mimeType });
  const objectUrl = URL.createObjectURL(blob);
  return {
    objectUrl,
    revoke: () => URL.revokeObjectURL(objectUrl),
  };
}

export function base64PdfToObjectUrl(base64Data: string): {
  objectUrl: string;
  revoke: () => void;
} {
  return base64ToObjectUrl(base64Data, 'application/pdf');
}
